import * as React from "react";
import Button from "@mui/joy/Button";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import DialogActions from "@mui/joy/DialogActions";
import { Modal } from "@mui/joy";
import ModalDialog from "@mui/joy/ModalDialog";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import Box from "@mui/joy/Box";

const ACCENT_BLUE = '#22638f';
const ACCENT_ORANGE = '#d96c3c';
const TEXT_MUTED = '#93a0b5';
const TEXT_BODY = '#3b4a63';
const BORDER = '#eef2f8';

const AlertDialogModal = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmButtonText,
  cancelButtonText,
  icon = <WarningRoundedIcon />,
}) => {
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <ModalDialog
        variant="outlined"
        role="alertdialog"
        sx={{
          borderRadius: '16px',
          border: `1px solid ${BORDER}`,
          boxShadow: '0 12px 40px rgba(12, 61, 110, 0.18)',
          width: 420,
          p: 3,
        }}
      >
        {title && (
          <DialogTitle
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              fontSize: 16,
              fontWeight: 700,
              color: TEXT_BODY,
              mb: 0,
            }}
          >
            <Box
              sx={{
                width: 34,
                height: 34,
                borderRadius: '10px',
                backgroundColor: 'rgba(217, 108, 60, 0.1)',
                color: ACCENT_ORANGE,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                '& svg': { fontSize: 19 },
              }}
            >
              {icon}
            </Box>
            {title}
          </DialogTitle>
        )}

        <Box sx={{ mt: 2 }}>
          <DialogContent sx={{ fontSize: 13.5, color: TEXT_MUTED, lineHeight: 1.6 }}>
            {message}
          </DialogContent>
        </Box>

        <DialogActions sx={{ mt: 3, gap: 1.5, justifyContent: 'flex-end' }}>
          {cancelButtonText && (
            <Button
              variant="outlined"
              onClick={onClose}
              sx={{
                borderRadius: '10px',
                textTransform: 'none',
                fontWeight: 600,
                borderColor: BORDER,
                color: TEXT_BODY,
                '&:hover': { borderColor: ACCENT_BLUE, backgroundColor: '#fafcff' },
              }}
            >
              {cancelButtonText}
            </Button>
          )}
          {confirmButtonText && (
            <Button
              variant="solid"
              onClick={onConfirm}
              sx={{
                borderRadius: '10px',
                textTransform: 'none',
                fontWeight: 600,
                boxShadow: 'none',
                backgroundColor: ACCENT_BLUE,
                '&:hover': { backgroundColor: '#1b4f73', boxShadow: 'none' },
              }}
            >
              {confirmButtonText}
            </Button>
          )}
        </DialogActions>
      </ModalDialog>
    </Modal>
  );
};

export default AlertDialogModal;